import React, { FC, useEffect, useState } from "react";
import { emailSettingFields } from "./clientAllFields";
import { Box, Grid, Typography } from "@mui/material";
import FormField from "../../../../components/common/FormField";
import { useDispatch } from "react-redux";
import {
  getCheckUniqueEmailAction,
  setCheckUniqueEmailAction,
  setNewClientLocal,
} from "../../../../store/reducers/adminClientsSlice";
import { useSelector } from "react-redux";
interface ManageEmailSettingProps {
  selectClient: any; // Adjust type as per your requirement,
  emailSettingError: any;
  formData?: any;
  setFormData?: any;
  checkValidator?: any;
  companyProfileIsError?: any;
  action?: any;
}
const EmailSettingForm: FC<ManageEmailSettingProps> = ({
  selectClient,
  emailSettingError,
  formData,
  setFormData,
  checkValidator,
  companyProfileIsError,
  action,
}) => {
  const dispatch = useDispatch();
  const { newClientLocal, isEmailError } = useSelector(
    (state: any) => state?.adminClients
  );
  const [isEmailActionCalled, setIsEmailActionCalled] = useState(false);
  const [isLoad, setIsLoad] = useState(false);

  const onChangeAction = (event: any) => {
    if (!isLoad) return event.preventDefault();

    const { id, value } = event.target;
    dispatch(
      setNewClientLocal({
        ...newClientLocal,
        emailSetting: {
          ...newClientLocal?.emailSetting,
          [id]: value,
        },
      })
    );
    setFormData((prevValues: any) => ({ ...prevValues, [id]: value }));
    dispatch(setCheckUniqueEmailAction(false));
  };

  const onBlurAction = (e: any) => {
    const { id, value } = e.target;
    checkValidator(e.target.id);
    if (id === "email" && value.trim() !== "") {
      setIsEmailActionCalled(true);
    }
  };

  useEffect(() => {
    if (isEmailActionCalled) {
      if (
        emailSettingError &&
        !emailSettingError["email"] &&
        isEmailActionCalled
      ) {
        dispatch(
          getCheckUniqueEmailAction(newClientLocal?.emailSetting?.email)
        );
        setIsEmailActionCalled(false);
      } else {
        setIsEmailActionCalled(false);
      }
    }
  }, [isEmailActionCalled]);

  return (
    <Box
      sx={{
        background: "#E5F4F1",
        paddingRight: "16px",
        paddingTop: "10px",
        border: "1px solid #CFCFCF",
        borderRadius: "5px",
      }}
    >
      {emailSettingFields?.map((field, i) => {
        return (
          !selectClient && (
            <Grid container spacing={2} key={i}>
              <FormField
                onPaste={(e: any) => e.preventDefault()}
                onKeyDown={(event: any) => {
                  if (
                    event.keyCode === "Unidentified" ||
                    event.keyCode === undefined ||
                    event.keyCode === "undefined"
                  ) {
                    event.preventDefault();
                  } else {
                    !isLoad && setIsLoad(true);
                  }
                }}
                {...{
                  ...field,
                  value: newClientLocal?.emailSetting
                    ? newClientLocal?.emailSetting[field?.id]
                    : "",
                  ...{
                    variant: "outlined", // Adding this variant prop
                    onChange: onChangeAction,
                    inSingleGridForm: true,
                    isNonMarginTop: true,
                    multiline:
                      (field?.id === "emailSignature" ||
                        field?.id === "emailDisclaimer") &&
                      true,
                    onBlur: onBlurAction,
                    InputProps: {
                      ...(field?.autocomplete && {
                        autocomplete: field?.autocomplete,
                      }),
                      ...(action === "edit" && {
                        disabled: field?.editReadOnly,
                      }),
                      sx:
                        field?.type === "text" || field?.type === "password"
                          ? {
                              height:
                                (field?.id === "emailSignature" ||
                                  field?.id === "emailDisclaimer") &&
                                newClientLocal?.emailSetting[field?.id]
                                  ?.length > 2
                                  ? "auto"
                                  : "36px",
                              padding:
                                field?.id === "emailSignature" ||
                                field?.id === "emailDisclaimer"
                                  ? "4px"
                                  : "",
                            }
                          : { padding: "10px 4px", height: "36px" },
                    },
                    error:
                      field?.id === "email" && isEmailError
                        ? true
                        : emailSettingError && emailSettingError[field?.id],
                    // helperText:
                    //   emailSettingError && emailSettingError[field?.id],
                  },
                }}
              />
            </Grid>
          )
        );
      })}
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          marginTop: "10px",
          fontSize: "13px",
          padding:'0px 16px'
        }}
      >
        <span style={{ color: "#d97c7c" }}>Note:- </span>
        <br />
        Please use your company domain email. If you use public domain emails,
        your customers will receive emails from removals@managemymoves.co.uk
        instead of your own email address. <br />
        Also, you will receive sender signature verification email from
        postmark. Please check contact, account email and customer service and confirm
        your sender signature so that your customers can receive emails from
        your own email.
      </Typography>
    </Box>
  );
};
export default EmailSettingForm;
